/**
 * @desc declarationPushEbs
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.DeclarationPushEbsRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/allocation/declarationPushEbs`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
